import { subQuarters } from "date-fns";

function calendarQuarter(d) {
  // Q1: Jan-Mar (month 0-2), Q2: Apr-Jun (3-5), Q3: Jul-Sep (6-8), Q4: Oct-Dec (9-11)
  return { year: d.getFullYear(), quarter: Math.floor(d.getMonth() / 3) + 1 };
}

export function quarterPresets(now = new Date()) {
  const thisQ = calendarQuarter(now);
  const lastQ = calendarQuarter(subQuarters(now, 1));
  return [
    { key: "this-q", label: "This Quarter", value: thisQ },
    { key: "last-q", label: "Last Quarter", value: lastQ },
  ];
}

/**
 * Companion to <FiscalPresetChips />, but for pickers that select a single
 * calendar quarter (e.g. Oman OTA quarterly VAT return). Emits {year, quarter}.
 */
export default function QuarterPresetChips({ year, quarter, onApply, testIdPrefix = "quarter-preset" }) {
  const presets = quarterPresets();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testIdPrefix}-chips`}>
      {presets.map((p) => {
        const active = year === p.value.year && quarter === p.value.quarter;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onApply(p.value.year, p.value.quarter)}
            data-testid={`${testIdPrefix}-${p.key}`}
            className={
              "text-[10px] font-mono tracking-[0.15em] uppercase px-2.5 py-1 border transition-colors " +
              (active
                ? "border-[#FF3E00] bg-[#FF3E00] text-white"
                : "border-zinc-300 bg-white text-zinc-700 hover:border-zinc-950 hover:bg-zinc-50")
            }
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
